module.exports = __webpack_public_path__ + "static/Sabatia kennedyana (Plymouth rose gentian)-b8bd48b08dcfc5500bf70c137e077463.jpg";